import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import config from './config';

async function warmUpAPI() {
  try {
    const response = await fetch(config.apiUrl);
    if (!response.ok) {
      throw new Error('Failed to warm up the API');
    }
    console.log('API warmed up successfully');
  } catch (error) {
    console.error('Error warming up the API:', error);
  }
}

warmUpAPI().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
